import React, { useState, createContext, useEffect, useCallback } from "react";
import { useAuth } from "../auth/AuthContext";
import API from "../API";
import { PROCURING_ENTITY_REPORTS_ENDPOINT } from "../API/endpoints";
import ProcessChartData from "../App/ProcuringEntities/components/ProcuringEntity/processData";
import { isoDateToHumanReadableDate } from "../Util";
import projectsAPI from "../API/projects";
// import Icon from "@ant-design/icons";
import {
  LineChartOutlined,
  PieChartOutlined,
  FileTextOutlined,
  FolderOpenOutlined,
  ExclamationOutlined,
  SettingOutlined,
  FileDoneOutlined
} from '@ant-design/icons';
import Packages from "../App/Packages";
import SafeGuard from "../App/SafeguardConcerns";
import Subproject from "../App/SubProjects/components/SubProject";
import ReportSummary from "../App/Reports/components/CreateReportForm/reportSummary";
import Gallery from "../App/components/Gallery";
import ProcuringEntity from "../App/ProcuringEntities/components/ProcuringEntity";
import ProjectGeoOverview from "../App/Projects/GeoOverview";
import CreateReportForm from "../App/Reports/components/CreateReportForm";
import HumanResources from "../App/Packages/componets/Package/HumanResource";
import EquipmentMobilization from "../App/Packages/componets/Package/EquipmentMobilization";
import Package from "../App/Packages/componets/Package";
import SubProject from "../App/SubProject";
// Removed custom SVG icon components; using Ant icons directly
import "./AppContext.css";
import * as AppPermissions from "../Util/permissions";
import FinancialStatus from "../App/Packages/componets/Package/FinancialStatus";
import ChallengesImplementations from "../App/Packages/componets/Package/ChallengesImplementations";
import ProblemsConstraints from "../App/Packages/componets/Package/ProblemsConstraints";
import Grivences from "../App/Packages/componets/Package/Grivences";
import IncidentAndAccidents from "../App/Packages/componets/Package/IncidentsAccidents";
import StatusRelocation from "../App/Packages/componets/Package/StatusRelocation";
import EnviromentalSafeguards from "../App/Packages/componets/Package/EnviromentalSafeguards";
import SocialSafeguards from "../App/Packages/componets/Package/SocialSafaguards";
import ContractorContractInfo from "../App/Packages/componets/Package/ContractorDetails";
import PackageMap from "../App/Packages/componets/Package/PackageMap";
import ChangePassword from "../App/Users/ChangePassword";
import Unauthorized from "../App/Auth/components/Unauthorized";
import ProjectActivities from "../App/SubProjects/ProjectActivities";
import CSCContractInfo from "../App/SubProjects";
import CSCRolesActivities from "../App/SubProjects/components/CSCRolesActivities";
import OnGoingPackageOverview from "../App/SubProjects/components/OnGoingPackageOverview";
import CSCStaffMobilization from "../App/SubProjects/components/CSCStaffMobilization";
import CscFinancialStatus from "../App/SubProjects/components/CscFinancialStatus";
import QualityControls from "../App/Packages/componets/Package/QualityControls";
import RapImplementation from "../App/Packages/componets/Package/RapImplementation";
import TrpImplementation from "../App/Packages/componets/Package/TrpImplementation";
import MaterialMobilizedTesting from "../App/Packages/componets/Package/MaterialMobilized";
import WorkSummaryPage from "../App/Packages/componets/Package/WorkSummaryPage";
import GeneralRecommendations from "../App/GeneralRecommendations";
import useSelectedReportDetails from "../hooks/useSelectedReportDetails";

const baseUrl = "/project/:projectId";
const sideMenuKeys = {
  project: "overview",
  reports: "reports",
  map: "sub-projects-map",
  contracts: "contracts",
  subProjects: "csc-activities",
  safeguardConcerns: "safeguard-concerns",
  packages: "packages",
  users: "users",
  roles: "roles",
  exceptions: "Exceptions",
  documenents: "Documents",
  changePassword: "change-password",
  unauthorized: "unauthorized",
  feedback: "Feedback",
  projectManagement: "project-management",
  settings: "settings",
};

const getRoutes = (menuKeys) => {
  const {
    lga,
    project,
    packages,
    subProjects,
    reports,
    safeguardConcerns,
    feedback,
    changePassword,
    unauthorized,
  } = menuKeys;
  return [
    {
      path: `${baseUrl}/${lga}`,
      component: ProcuringEntity,
      exact: true,
      requiredPermissions: [AppPermissions.CAN_READ_PROCURING_ENTITY],
    },
    {
      path: `${baseUrl}/${project}`,
      component: ProjectGeoOverview,
      exact: true,
      requiredPermissions: [AppPermissions.CAN_READ_PROJECT],
    },
    {
      path: `${baseUrl}/regions/:regionId/overview`,
      component: ProjectGeoOverview,
      exact: true,
      requiredPermissions: [AppPermissions.CAN_READ_PROJECT],
    },
    {
      path: `${baseUrl}/councils/:councilId/lga-overview`,
      component: ProjectGeoOverview,
      exact: true,
      requiredPermissions: [AppPermissions.CAN_READ_PROCURING_ENTITY],
    },

    {
      path: `${baseUrl}/${safeguardConcerns}`,
      component: SafeGuard,
      exact: true,
    },
    {
      path: `${baseUrl}/procuring_entity/:procuringEntityId/${packages}`,
      component: Packages,
      exact: true,
    },
    {
      path: `${baseUrl}/procuring_entity/:procuringEntityId/${packages}/:packageId`,
      component: Package,
      exact: true,
    },
    {
      path: `${baseUrl}/${feedback}`,
      component: () => {
        // window.open("https://www.google.com/", "_blank");
        window.location.href = "https://www.google.com/";
        return null;
      },
      exact: true,
    },
    {
      path: `${baseUrl}/procuring_entity/:procuringEntityId/${packages}/:packageId/staff`,
      component: HumanResources,
      exact: true,
    },

    {
      path: `${baseUrl}/procuring_entity/:procuringEntityId/${packages}/:packageId/equipment-mobilization`,
      component: EquipmentMobilization,
      exact: true,
    },

    {
      path: `${baseUrl}/procuring_entity/:procuringEntityId/${packages}/:packageId/financial-status`,
      component: FinancialStatus,
      exact: true,
    },
    {
      path: `${baseUrl}/procuring_entity/:procuringEntityId/${packages}/:packageId/rap_trp_implementation`,
      component: RapImplementation,
      exact: true,
    },
    {
      path: `${baseUrl}/procuring_entity/:procuringEntityId/${packages}/:packageId/trp_trp_implementation`,
      component: TrpImplementation,
      exact: true,
    },
    {
      path: `${baseUrl}/procuring_entity/:procuringEntityId/${packages}/:packageId/material_Mobilized_Testing`,
      component: MaterialMobilizedTesting,
      exact: true,
    },
    {
      path: `${baseUrl}/procuring_entity/:procuringEntityId/${packages}/:packageId/challenges-implementation`,
      component: ChallengesImplementations,
      exact: true,
    },
    {
      path: `${baseUrl}/procuring_entity/:procuringEntityId/${packages}/:packageId/problems-constraints`,
      component: ProblemsConstraints,
      exact: true,
    },
    {
      path: `${baseUrl}/procuring_entity/:procuringEntityId/${packages}/:packageId/grivences`,
      component: Grivences,
      exact: true,
    },
    {
      path: `${baseUrl}/procuring_entity/:procuringEntityId/${packages}/:packageId/incidents-accidents`,
      component: IncidentAndAccidents,
      exact: true,
    },
    {
      path: `${baseUrl}/procuring_entity/:procuringEntityId/${packages}/:packageId/status-relocation`,
      component: StatusRelocation,
      exact: true,
    },
    {
      path: `${baseUrl}/procuring_entity/:procuringEntityId/${packages}/:packageId/enviromental-safeguards`,
      component: EnviromentalSafeguards,
      exact: true,
    },
    {
      path: `${baseUrl}/procuring_entity/:procuringEntityId/${packages}/:packageId/social-safeguards`,
      component: SocialSafeguards,
      exact: true,
    },
    {
      path: `${baseUrl}/procuring_entity/:procuringEntityId/${packages}/:packageId/contract-details`,
      component: ContractorContractInfo,
      exact: true,
    },
    {
      path: `${baseUrl}/procuring_entity/:procuringEntityId/${packages}/:packageId/quality-controls`,
      component: QualityControls,
      exact: true,
    },
    {
      path: `${baseUrl}/procuring_entity/:procuringEntityId/${packages}/:packageId/Gallery`,
      component: Gallery,
      exact: true,
    },
    {
      path: `${baseUrl}/procuring_entity/:procuringEntityId/${packages}/:packageId/map`,
      component: PackageMap,
      exact: true,
    },
    {
      path: `${baseUrl}/procuring_entity/:procuringEntityId/${packages}/:packageId/general-recommendations`,
      component: GeneralRecommendations,
      exact: true,
    },
    {
      path: `${baseUrl}/procuring_entity/:procuringEntityId/${packages}/:packageId/work-summary`,
      component: WorkSummaryPage,
      exact: true,
    },
    {
      path: `${baseUrl}/${reports}`,
      component: ProjectActivities,
      exact: true,
    },
    {
      path: `${baseUrl}/procuring_entity/:procuringEntityId/${reports}`,
      component: ProjectActivities,
      exact: true,
    },
    {
      path: `${baseUrl}/procuring_entity/:procuringEntityId/${packages}/:packageId/subprojects/:subprojectId`,
      component: SubProject,
      exact: true,
    },
    {
      path: `${baseUrl}/procuring_entity/:procuringEntityId/${reports}/:reportId`,
      component: ReportSummary,
      exact: true,
    },
    {
      path: `${baseUrl}/${subProjects}/csc_contract_info`,
      component: CSCContractInfo,
      exact: true,
    },
    {
      path: `${baseUrl}/${subProjects}/csc_roles`,
      component: CSCRolesActivities,
      exact: true,
    },
    {
      path: `${baseUrl}/${subProjects}/on_going_package_overview`,
      component: OnGoingPackageOverview,
      exact: true,
    },
    {
      path: `${baseUrl}/${subProjects}/csc_staff_mobilization`,
      component: CSCStaffMobilization,
      exact: true,
    },
    {
      path: `${baseUrl}/${subProjects}/csc_financial_status`,
      component: CscFinancialStatus,
      exact: true,
    },
    {
      path: `${baseUrl}/procuring_entity/:procuringEntityId/${reports}/create`,
      component: CreateReportForm,
      exact: true,
    },
    {
      path: `${baseUrl}/${subProjects}/:subProjectId`,
      component: Subproject,
      exact: false,
    },
    {
      path: `${baseUrl}/${changePassword}`,
      component: ChangePassword,
      exact: false,
    },
    {
      path: `${baseUrl}/${unauthorized}`,
      component: Unauthorized,
      exact: false,
    },
  ];
};

const iconStyle = { fontSize: "18px", color: "#0f6788cc" };

const normalizeReportId = (value) => {
  if (value === undefined || value === null) return null;
  if (typeof value === "string") {
    const trimmed = value.trim();
    if (!trimmed) return null;
    const lower = trimmed.toLowerCase();
    if (lower === "null" || lower === "undefined") return null;
    const numericCandidate = Number(trimmed);
    return Number.isNaN(numericCandidate) ? trimmed : numericCandidate;
  }
  return value;
};

const reportIdsMatch = (a, b) => {
  if (a === null || a === undefined) return b === null || b === undefined;
  if (b === null || b === undefined) return false;
  return `${a}` === `${b}`;
};


const getMenuItems = (menuKeys, permissions, contextState = {}) => {
  const {
    packages,
    project,
    exceptions,
    documenents,
    reports,
    projectManagement,
    settings,
  } = menuKeys;

  return [
    {
      key: project,
      icon: <LineChartOutlined style={{ ...iconStyle }} className="navmenu-icon"/>,
      label: "Project Overview",
      disabled: !permissions.includes(AppPermissions.CAN_READ_PROJECT),
    },
    {
      key: packages,
      // icon: <PackagesIcon />,
      icon: <PieChartOutlined style={{ ...iconStyle }} className="navmenu-icon"/>,
      label: "Packages",
      disabled: !permissions.includes(AppPermissions.CAN_READ_PACKAGE),
    },
    {
      key: reports,
      // icon: <ReportsIcon />,
      icon: <FileTextOutlined style={{ ...iconStyle }} className="navmenu-icon"/>,
      label: "Progress Reports",
      disabled: !permissions.includes(AppPermissions.CAN_READ_REPORT),
    },
    {
      key: documenents,
      // icon: <DocumentsIcon />,
      icon: <FolderOpenOutlined style={{ ...iconStyle }} className="navmenu-icon"/>,
      label: "Documents",
      disabled: !permissions.includes(AppPermissions.CAN_READ_DOCUMENT),
    },
    {
      key: exceptions,
      // icon: <ExceptionsIcon />,
      icon: <ExclamationOutlined style={{ ...iconStyle }} className="navmenu-icon"/>,
      label: "Errors & Exceptions",
      disabled: !permissions.includes(AppPermissions.CAN_READ_EXCEPTION),
    },
    {
      key: projectManagement,
      icon: <FileDoneOutlined style={{ ...iconStyle }} className="navmenu-icon"/>,
      label: "Project Management",
      disabled: false,
    },
    {
      key: settings,
      // icon: <SettingsIcon />,
      icon: <SettingOutlined style={{ ...iconStyle }} className="navmenu-icon"/>,
      label: "Settings",
      disabled: !permissions.includes(AppPermissions.CAN_READ_EXCEPTION),
    },
  ];
};

const appRoutes = getRoutes(sideMenuKeys);

export const AppContext = createContext({});

const AppContextProvider = ({ children }) => {
  const { user: authUser, permissions: authPermissions, token } = useAuth();
  const [currentUser, setCurrentUser] = useState(() => {
    const stored = localStorage.getItem("user");
    return stored ? JSON.parse(stored) : authUser || null;
  });
  useEffect(() => {
    if (authUser) {
      setCurrentUser(authUser);
      try { localStorage.setItem("user", JSON.stringify(authUser)); } catch { }
    }
  }, [authUser]);
  const permissions = authPermissions && authPermissions.length ? authPermissions : [];

  const [selectedRegionId, setSelectedRegionId] = useState(() => {
    const savedSelectedRegionId = localStorage.getItem("selectedRegionId");
    return savedSelectedRegionId ? JSON.parse(savedSelectedRegionId) : null;
  });
  // Selected Council for LGA Overview mnu and routing
  const [selectedCouncilId, setSelectedCouncilId] = useState(() => {
    const savedSelectedCouncilId = localStorage.getItem("selectedCouncilId");
    return savedSelectedCouncilId ? JSON.parse(savedSelectedCouncilId) : null;
  });
  // Human-readable names for summary display
  const [selectedRegionName, setSelectedRegionName] = useState(null);
  const [selectedCouncilName, setSelectedCouncilName] = useState(null);

  const removeDisabledMenuItems = () => {
    const menuItems = getMenuItems(sideMenuKeys, permissions, { selectedRegionId, selectedCouncilId });
    return menuItems.filter(({ disabled }) => !disabled);
  };

  const menuItems = removeDisabledMenuItems();

  const [apiData] = useState(null);
  const [loading] = useState(false);
  const [error] = useState(null);
  const [currentPackageData, setCurrentPackageData] = useState(null); // State to hold the current API endpoint

  const [reportingMonth, setReportingMonth] = useState("");

  const [reportingYear, setReportingYear] = useState("");

  const [selectedProcuringEntity, setSelectedProcuringEntity] = useState(null);

  const [selectedProject, setSelectedProject] = useState(null);

  const [projects, setProjects] = useState([]);

  // Loader to fetch and transform projects into the UI shape
  const ensureProjects = useCallback(async () => {
    const res = await API.getProjects();
    const list = res?.data?.data || [];
    const transformed = list.map((project) => ({
      id: project.id,
      name: project.name,
      code: project.code,
      wb_project_id: project.wb_project_id,
      project_status_id: project.project_status_id,
      procuring_entities: (project.procuring_entities || []).map((entity) => ({
        procuring_entity_id: entity.procuring_entity_id,
        council_name: entity.council?.name,
        council_id: entity.council?.id ?? null,
        region_id: entity.council?.region_id ?? null,
      })),
    }));
    setProjects(transformed);
    return transformed;
  }, []);


  const [reports, setReports] = useState(null);

  const [selectedReportID, setSelectedReportIDState] = useState(() => {
    const savedSelectedReportID = localStorage.getItem("selectedReportID");
    return savedSelectedReportID !== null
      ? JSON.parse(savedSelectedReportID)
      : null;
  });

  const [selectedReportDetails, setSelectedReportDetails] = useState(null);

  const setSelectedReportID = useCallback(
    (nextId, maybeOptions) => {
      const normalized = normalizeReportId(nextId);
      const options =
        maybeOptions && typeof maybeOptions === "object" && !Array.isArray(maybeOptions)
          ? maybeOptions
          : {};
      const skipDetailsReset =
        typeof options.skipDetailsReset === "boolean" ? options.skipDetailsReset : false;
      let shouldResetDetails = false;
      setSelectedReportIDState((prev) => {
        if (reportIdsMatch(prev, normalized)) {
          return prev;
        }
        if (!skipDetailsReset) {
          shouldResetDetails = true;
        }
        return normalized;
      });
      if (shouldResetDetails) {
        setSelectedReportDetails(null);
      }
    },
    [setSelectedReportDetails]
  );

  // Global CSC filter date range [startISO, endISO]
  const [selectedCscDateRange, setSelectedCscDateRange] = useState([null, null]);

  // Lifted lists for header filters
  const [regionOptions, setRegionOptions] = useState([]);
  const [councilOptions, setCouncilOptions] = useState([]);
  const [cscReportOptions, setCscReportOptions] = useState([]);
  const [isRegionOptionsLoading, setIsRegionOptionsLoading] = useState(false);
  const [isCouncilOptionsLoading, setIsCouncilOptionsLoading] = useState(false);

  // Procuring entity stats cache: id -> { loading, error, data: { physicalProgressData, financialProgressData, summaries } }
  const [procuringEntityStatsById, setProcuringEntityStatsById] = useState({});

  // Subprojects cache keyed by a stable string (usually by procuring_entity_id)
  const [subProjectsByKey, setSubProjectsByKey] = useState({});

  const [goToOverviewPage, setGoToOverviewPage] = useState(false);

  useEffect(() => {
    if (currentUser) {
      localStorage.setItem("user", JSON.stringify(currentUser));
    }
  }, [currentUser]);

  // When auth token becomes null (logout), reset in-memory context state to defaults
  useEffect(() => {
    if (!token) {
      // Clear localStorage for a clean slate
      try {
        localStorage.removeItem("user");
        localStorage.removeItem("reportingMonth");
        localStorage.removeItem("reportingYear");
        localStorage.removeItem("selectedProcuringEntity");
        localStorage.removeItem("selectedProject");
        localStorage.removeItem("projects");
        localStorage.removeItem("reports");
        localStorage.removeItem("selectedReportID");
        localStorage.removeItem("selectedRegionId");
        localStorage.removeItem("selectedCouncilId");
        localStorage.removeItem("selectedRegionName");
        localStorage.removeItem("selectedCouncilName");
        localStorage.removeItem("selectedCscDateRange");
      } catch {}
      setCurrentUser(null);
      setReportingMonth("");
      setReportingYear("");
      setSelectedProcuringEntity(null);
      setSelectedProject(null);
      setProjects([]);
      setReports(null);
      setSelectedReportID(null);
      setSelectedRegionId(null);
      setSelectedCouncilId(null);
      setSelectedRegionName(null);
      setSelectedCouncilName(null);
      setSelectedCscDateRange([null, null]);
      setSelectedReportDetails(null);
      setRegionOptions([]);
      setCouncilOptions([]);
      setCscReportOptions([]);
      setProcuringEntityStatsById({});
      setSubProjectsByKey({});
      setCurrentPackageData(null);
      setGoToOverviewPage(false);
      setIsRegionOptionsLoading(false);
      setIsCouncilOptionsLoading(false);
    }
  }, [token]);

  // Also listen to a global logout event (dispatched by AuthContext) for robustness
  useEffect(() => {
    const handler = () => {
      // Clear localStorage for a clean slate
      try {
        localStorage.removeItem("user");
        localStorage.removeItem("reportingMonth");
        localStorage.removeItem("reportingYear");
        localStorage.removeItem("selectedProcuringEntity");
        localStorage.removeItem("selectedProject");
        localStorage.removeItem("projects");
        localStorage.removeItem("reports");
        localStorage.removeItem("selectedReportID");
        localStorage.removeItem("selectedRegionId");
        localStorage.removeItem("selectedCouncilId");
        localStorage.removeItem("selectedRegionName");
        localStorage.removeItem("selectedCouncilName");
        localStorage.removeItem("selectedCscDateRange");
      } catch {}
      setCurrentUser(null);
      setReportingMonth("");
      setReportingYear("");
      setSelectedProcuringEntity(null);
      setSelectedProject(null);
      setProjects([]);
      setReports(null);
      setSelectedReportID(null);
      setSelectedRegionId(null);
      setSelectedCouncilId(null);
      setSelectedRegionName(null);
      setSelectedCouncilName(null);
      setSelectedCscDateRange([null, null]);
      setSelectedReportDetails(null);
      setRegionOptions([]);
      setCouncilOptions([]);
      setCscReportOptions([]);
      setProcuringEntityStatsById({});
      setSubProjectsByKey({});
      setCurrentPackageData(null);
      setGoToOverviewPage(false);
      setIsRegionOptionsLoading(false);
      setIsCouncilOptionsLoading(false);
    };
    window.addEventListener('pst:auth:logout', handler);
    return () => window.removeEventListener('pst:auth:logout', handler);
  }, []);

  useEffect(() => {
    // Do not persist when logged out
    if (!token) return;
    if (selectedReportID) {
      localStorage.setItem(
        "selectedReportID",
        JSON.stringify(selectedReportID)
      );
    } else {
      try { localStorage.removeItem("selectedReportID"); } catch {}
    }
  }, [selectedReportID, token]);

  useEffect(() => {
    // Do not persist when logged out
    if (!token) return;
    if (selectedRegionId) {
      localStorage.setItem("selectedRegionId", JSON.stringify(selectedRegionId));
    } else {
      try { localStorage.removeItem("selectedRegionId"); } catch {}
    }
  }, [selectedRegionId, token]);

  useEffect(() => {
    // Do not persist when logged out
    if (!token) return;
    if (selectedCouncilId) {
      localStorage.setItem("selectedCouncilId", JSON.stringify(selectedCouncilId));
    } else {
      try { localStorage.removeItem("selectedCouncilId"); } catch {}
    }
  }, [selectedCouncilId, token]);

  const {
    loading: selectedReportLoading,
    error: selectedReportError,
    status: selectedReportStatus,
    refetch: refetchSelectedReportDetails,
  } = useSelectedReportDetails(selectedReportID, setSelectedReportDetails);

  // Report is the source of truth: sync dependent filters from loaded report details
  useEffect(() => {
    if (!selectedReportDetails) return;
    const {
      project_id,
      region_id,
      council_id,
      procuring_entity_id,
      start,
      end,
      project,
      region,
      council,
    } = selectedReportDetails;

    if (project_id != null && `${selectedProject}` !== `${project_id}`) {
      setSelectedProject(project_id);
    }

    if (region?.name) {
      setSelectedRegionName(region.name);
    }
    if (region_id != null && `${selectedRegionId}` !== `${region_id}`) {
      setSelectedRegionId(region_id);
    }
    setRegionOptions((prev) => {
      if (region_id == null || region?.name == null) return prev;
      const exists = prev.some((opt) => `${opt.value}` === `${region_id}`);
      return exists ? prev : [...prev, { value: region_id, label: region.name }];
    });

    if (council?.name) {
      setSelectedCouncilName(council.name);
    }
    if (council_id != null && `${selectedCouncilId}` !== `${council_id}`) {
      setSelectedCouncilId(council_id);
    }
    setCouncilOptions((prev) => {
      if (council_id == null || council?.name == null) return prev;
      const exists = prev.some((opt) => `${opt.value}` === `${council_id}`);
      return exists ? prev : [...prev, { value: council_id, label: council.name }];
    });

    if (procuring_entity_id != null && `${selectedProcuringEntity}` !== `${procuring_entity_id}`) {
      setSelectedProcuringEntity(procuring_entity_id);
    }

    const nextStart = start || null;
    const nextEnd = end || null;
    const [curStart, curEnd] = selectedCscDateRange || [null, null];
    if (nextStart !== curStart || nextEnd !== curEnd) {
      setSelectedCscDateRange([nextStart, nextEnd]);
    }
  }, [selectedReportDetails]);

  // Keep region options in sync with selected project
  useEffect(() => {
    if (!selectedProject) {
      setRegionOptions([]);
      setIsRegionOptionsLoading(false);
      return;
    }
    setIsRegionOptionsLoading(true);
    projectsAPI
      .getProjectRegions(selectedProject, 1, 100, { fields: 'id,name' })
      .then((res) => {
        const regs = res?.data?.data || [];
        setRegionOptions(regs.map((r) => ({ value: r.id, label: r.name })));
        setIsRegionOptionsLoading(false);
      })
      .catch(() => {
        setRegionOptions([]);
        setIsRegionOptionsLoading(false);
      });
  }, [selectedProject]);

  // Keep council options in sync with selected project and region
  useEffect(() => {
    if (selectedProject && selectedRegionId) {
      setIsCouncilOptionsLoading(true);
      projectsAPI
        .getProjectRegionCouncils(selectedProject, selectedRegionId)
        .then((res) => {
          const councils = res.data || [];
          setCouncilOptions(councils.map((c) => ({ value: c.id, label: c.name })));
          setIsCouncilOptionsLoading(false);
        })
        .catch(() => {
          setCouncilOptions([]);
          setIsCouncilOptionsLoading(false);});
    } else {
      setCouncilOptions([]);
      setIsCouncilOptionsLoading(false);
    }
  }, [selectedProject, selectedRegionId]);

  // Keep report options in sync with selected filters
  useEffect(() => {
    const [start, end] = selectedCscDateRange || [];
    if (!selectedProject && !selectedProcuringEntity) {
      setCscReportOptions([]);
      return;
    }
    if (!selectedCouncilId && !selectedProcuringEntity) {
      setCscReportOptions([]);
      return;
    }
    (async () => {
      try {
        const filter = {};
        if (selectedProject) {
          filter["filter[project_id]"] = selectedProject;
        }
        if (selectedCouncilId) {
          filter["filter[council_id]"] = selectedCouncilId;
        } else if (selectedProcuringEntity) {
          filter["filter[procuring_entity_id]"] = selectedProcuringEntity;
        }
        if (start && end) {
          filter["filter[report_start_date]"] = start;
          filter["filter[report_end_date]"] = end;
        }
        const response = await API.get(PROCURING_ENTITY_REPORTS_ENDPOINT, filter);
        const opts = (response || []).map((report) => ({
          value: report.id,
          label: `RN #${report.report_number}: ${isoDateToHumanReadableDate(report.start)} - ${isoDateToHumanReadableDate(report.end)}`,
        }));
        setCscReportOptions(opts || []);
        const hasMatch = (opts || []).some((opt) => `${opt.value}` === `${selectedReportID}`);
        if (!hasMatch) {
          setSelectedReportID(null);
        }
      } catch (e) {
        setCscReportOptions([]);
      }
    })();
  }, [selectedProject, selectedCouncilId, selectedProcuringEntity, selectedCscDateRange, selectedReportID]);

  useEffect(() => {
    if (!selectedProject || !selectedCouncilId) return;
    const projectEntry = Array.isArray(projects)
      ? projects.find((p) => `${p.id}` === `${selectedProject}`)
      : null;
    const matchedEntity = projectEntry?.procuring_entities?.find(
      (entity) => entity.council_id != null && `${entity.council_id}` === `${selectedCouncilId}`
    );
    if (matchedEntity && `${selectedProcuringEntity}` !== `${matchedEntity.procuring_entity_id}`) {
      setSelectedProcuringEntity(matchedEntity.procuring_entity_id);
    }
  }, [projects, selectedProject, selectedCouncilId, selectedProcuringEntity]);

  const selectProcuringEntity = (curretProcuringEntityID) => {
    if (curretProcuringEntityID !== selectedProcuringEntity) {
      setSelectedProcuringEntity(curretProcuringEntityID);
    }
  };

  const setActiveProject = (projectId, maybeProcuringEntityId) => {
    if (projectId == null) return;
    if (projectId !== selectedProject) {
      setSelectedProject(projectId);
    }
    const projectObj = Array.isArray(projects) ? projects.find(p => `${p.id}` === `${projectId}`) : null;
    let peId = maybeProcuringEntityId;
    if (!peId && projectObj && Array.isArray(projectObj.procuring_entities) && projectObj.procuring_entities.length) {
      peId = projectObj.procuring_entities[0].procuring_entity_id;
    }
    if (peId && peId !== selectedProcuringEntity) {
      setSelectedProcuringEntity(peId);
    }
  };

  // Ensure latest reports + stats for a procuring entity are loaded and cached
  const ensureProcuringEntityStatsLatest = useCallback((id) => {
    if (!id) return;
    setProcuringEntityStatsById((prev) => {
      const entry = prev[id];
      if (entry?.loading || entry?.data) return prev;
      return { ...prev, [id]: { ...(entry || {}), loading: true, error: null } };
    });
    (async () => {
      try {
        const filter = { "filter[procuring_entity_id]": id };
        const response = await API.get(PROCURING_ENTITY_REPORTS_ENDPOINT, filter);
        const reportsSummary = (response || []).map((report) => ({
          id: report.id,
          report_number: report.report_number,
          start: report.start,
          end: report.end,
        }));
        setReports(reportsSummary);

        const defaultReport = reportsSummary?.[reportsSummary.length - 1];
        const reportIds = reportsSummary.map((r) => r.id);
        const exists = reportIds.includes(selectedReportID);
        if (selectedReportID === null || !exists) {
          setSelectedReportID(defaultReport?.id ?? null);
        }

        if (!defaultReport) {
          setProcuringEntityStatsById((prev) => ({
            ...prev,
            [id]: { loading: false, error: null, data: { physicalProgressData: [], financialProgressData: [], summaries: [] } },
          }));
          return;
        }

        const res = await API.getProcuringEntitiesStatistics(id, defaultReport.start, defaultReport.end);
        const overviewData = ProcessChartData(res.data.package_progress);
        const physicalProgressData = overviewData?.physicalProgress || [];
        const financialProgressData = overviewData?.financialProgress || [];
        const summaries = [
          { label: "Packages", value: res.data.packages },
          { label: "Sub Projects", value: res.data.subProjects },
          { label: "Contractors", value: res.data.contractors },
          {
            value:
              res.data.reports?.length > 0
                ? `${isoDateToHumanReadableDate(res.data.reports[0]?.start, "MMM Do")} - ${isoDateToHumanReadableDate(res.data.reports[0]?.end, "Do")}, ${isoDateToHumanReadableDate(res.data.reports[0]?.end, "YYYY")}`
                : null,
            label: "Latest Report",
            cardType: "date",
          },
        ];

        setProcuringEntityStatsById((prev) => ({
          ...prev,
          [id]: { loading: false, error: null, data: { physicalProgressData, financialProgressData, summaries } },
        }));
      } catch (error) {
        setProcuringEntityStatsById((prev) => ({
          ...prev,
          [id]: { loading: false, error: error?.message || "Failed to fetch stats", data: null },
        }));
      }
    })();
  }, [selectedReportID]);

  // Lightweight reports loader separate from stats
  const ensureReports = useCallback(async (procuringEntityId) => {
    if (!procuringEntityId) return [];
    const filter = { "filter[procuring_entity_id]": procuringEntityId };
    const response = await API.get(PROCURING_ENTITY_REPORTS_ENDPOINT, filter);
    const reportsSummary = (response || []).map((report) => ({
      id: report.id,
      report_number: report.report_number,
      start: report.start,
      end: report.end,
    }));
    setReports(reportsSummary);
    // maintain selected report
    const ids = reportsSummary.map((r) => r.id);
    const exists = ids.includes(selectedReportID);
    if (selectedReportID === null || !exists) {
      const latest = reportsSummary[reportsSummary.length - 1];
      setSelectedReportID(latest?.id ?? null);
    }
    return reportsSummary;
  }, [selectedReportID]);

  // Build a stable cache key for subprojects filter
  const makeSubProjectsKey = useCallback((filterObj) => {
    try {
      const pe = filterObj?.["filter[procuring_entity_id]"]; // common pattern
      if (pe != null) return `pe:${pe}`;
      // Fallback to stable stringify by sorting keys
      const entries = Object.entries(filterObj || {}).sort(([a], [b]) => (a > b ? 1 : -1));
      return `sp:${JSON.stringify(entries)}`;
    } catch {
      return `sp:${String(filterObj)}`;
    }
  }, []);

  // Ensure subprojects loaded for a filter
  const ensureSubProjects = useCallback((filterObj) => {
    const key = makeSubProjectsKey(filterObj);
    setSubProjectsByKey((prev) => {
      const entry = prev[key];
      if (entry?.loading || entry?.data) return prev;
      return { ...prev, [key]: { data: entry?.data || [], loading: true, error: null, ts: entry?.ts || null } };
    });
    (async () => {
      try {
        const res = await API.getSubProjects(filterObj);
        setSubProjectsByKey((prev) => ({
          ...prev,
          [key]: { data: res?.data ?? [], loading: false, error: null, ts: Date.now() },
        }));
      } catch (error) {
        setSubProjectsByKey((prev) => ({
          ...prev,
          [key]: { data: [], loading: false, error: error?.message || 'Failed to fetch subprojects', ts: Date.now() },
        }));
      }
    })();
  }, [makeSubProjectsKey]);

  // When a procuring entity is selected, ensure we have its data and derive the
  // selected council id from the procuring entity if available. This keeps
  // `selectedCouncilId` in sync with the selected procuring entity so routing
  // and LGA-overview views work correctly when a PE is chosen.
  useEffect(() => {
    if (!selectedProcuringEntity) return;
  }, [selectedProcuringEntity, selectedCouncilId]);

  return (
    <AppContext.Provider
      value={{
        appRoutes,
        menuItems,
        sideMenuKeys,
        permissions,
        reportingMonth,
        reportingYear,
        reports,
        selectedReportID,
        selectedReportDetails,
        selectedReportLoading,
        selectedReportError,
        selectedReportStatus,
        refetchSelectedReportDetails,
        selectedProcuringEntity,
        projects,
        selectedProject,
        goToOverviewPage,
        setGoToOverviewPage,
        selectProcuringEntity,
        setProjects,
        setSelectedProject,
        setActiveProject,
        setCurrentUser,
        setReports,
        setSelectedReportID,
        setSelectedReportDetails,
        setReportingMonth,
        setReportingYear,
        currentPackageData,
  apiData,
  loading,
  error,
  setCurrentPackageData,
  selectedRegionId,
  setSelectedRegionId,
  selectedCouncilId,
  setSelectedCouncilId,
  selectedRegionName,
  setSelectedRegionName,
  selectedCouncilName,
  setSelectedCouncilName,
  selectedCscDateRange,
  setSelectedCscDateRange,
  regionOptions,
  councilOptions,
  cscReportOptions,
  isRegionOptionsLoading,
  isCouncilOptionsLoading,
  // Projects & reports loaders
  ensureProjects,
  ensureReports,
  ensureProcuringEntityStatsLatest,
  procuringEntityStatsById,
  // Subprojects cache & loader
  subProjectsByKey,
  ensureSubProjects,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};
export default AppContextProvider;
